module.exports = __webpack_public_path__ + "static/img/eq4.18cb50e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/szr/eq4.png
// module id = nghb
// module chunks = 0